export type UserRole = 'admin' | 'operator' | 'cashier';

export interface AuthUser {
  name: string;
  role: UserRole;
}

export interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  user: AuthUser | null;
}

const STORAGE_KEY = 'prototype_auth_session';

export const defaultAuthState: AuthState = {
  isAuthenticated: false,
  token: null,
  user: null,
};

export const loadAuthState = (): AuthState => {
  if (typeof window === 'undefined') {
    return defaultAuthState;
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return defaultAuthState;
    }

    const parsed = JSON.parse(raw) as AuthState;
    if (!parsed.isAuthenticated || !parsed.token || !parsed.user) {
      return defaultAuthState;
    }

    return parsed;
  } catch {
    return defaultAuthState;
  }
};

export const persistAuthState = (state: AuthState) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!state.isAuthenticated) {
    window.localStorage.removeItem(STORAGE_KEY);
    return;
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
};
